module.exports = __webpack_public_path__ + "static/img/process01.png";